<template>
  <div class="SiteMap">
    <div class="container_w">
      <bread-crumb :crumbList="crumbList"></bread-crumb>
      <page-header :headerTitle="headerTitle"></page-header>
      <div class="each_map" v-for="(item,index) in sitemapList" :key="index">
          <h3>{{item.titleName}}</h3>
          <ul class="clear" v-if="item.childList">
            <li class="left" v-for="(i,k) in item.childList" :key="k">
                <router-link class="ellipsis" :to="i.toLink" :title="i.childName">{{i.childName}}</router-link>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>

import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
import PageHeader from "@/components/PageHeader/PageHeader";
export default {
  components: {
    BreadCrumb,
    PageHeader,
  },
  name: "SiteMap",
  data() {
    return {
        crumbList:[
            {
                name:'Site Map',
                url:''
            }
        ],
      headerTitle:'Site Map',
      sitemapList:[
          {
              titleName:'Home',
              toLink:'/',
          },
          {
              titleName:'Book a Flight',
              toLink:'/',
          },
          {
              titleName:'Preparing for Flight',
              toLink:'/',
          },
          {
              titleName:'Special Offer',
              toLink:'/',
          },
          {
              titleName:'Information',
              toLink:'/',
              childList:[
                  {
                      childName:'Bookings',
                      toLink:'/',
                  },
                  {
                      childName:'Baggage',
                      toLink:'/',
                  },
                  {
                      childName:'Special Assistance',
                      toLink:'/',
                  },
                  {
                      childName:'Assitance',
                      toLink:'/',
                  },
                  {
                      childName:'Travel Experience',
                      toLink:'/',
                  },
                  {
                      childName:'Other Service',
                      toLink:'/',
                  },
              ]
          },
          {
              titleName:'Golden Panda Club',
              toLink:'/',
              childList:[
                  {
                      childName:'Service Guide of SCA…',
                      toLink:'/',
                  },
              ]
          },
          {
              titleName:'About',
              toLink:'/',
              childList:[
                  {
                      childName:'About Us',
                      toLink:'/',
                  },
                  {
                      childName:'Contact Us',
                      toLink:'/',
                  },
                  {
                      childName:'News',
                      toLink:'/',
                  },
              ]
          },
          {
              titleName:'Support',
              toLink:'/',
              childList:[
                  {
                      childName:'Site Map',
                      toLink:'/',
                  },
              ]
          },
          {
              titleName:'Policy',
              toLink:'/',
              childList:[
                  {
                      childName:'Cookie Policy',
                      toLink:'/',
                  },
                  {
                      childName:'Privacy Policy',
                      toLink:'/',
                  },
              ]
          },
      ]
    };
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {
      console.log(SITEMAPJSON)
    // this.$Ajax.get('/Content/Scripts/SITEMAP.js')
    // .then( (response)=> {
    //     console.log(response.data)
    // })
    // .catch( (error) =>{
    //     console.log(error);
    // });
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
.SiteMap{
    .container_w{
        padding-bottom: 96px;
        .each_map{
            padding-top: 48px;
            h3{
                font-size:18px;
                color:rgba(51,51,51,1);
                line-height:21px;
            }
            ul{
                padding-top: 16px;
                li{
                    padding: 8px 0;
                    margin-right: 32px;
                    a{
                        font-size:14px;
                        color:rgba(128,128,128,1);
                        line-height:16px;
                        display: inline-block;
                        width: 160px;
                    }
                    &:nth-child(6n){
                        margin-right: 0;
                    }
                }
            }
        }
    }
}

</style>
